import { render, staticRenderFns } from "./PopupEditDocument.vue?vue&type=template&id=5583f4c7"
import script from "./PopupEditDocument.vue?vue&type=script&lang=ts"
export * from "./PopupEditDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports